import { RoleTypes, CombinedFlows, RecipientTypes } from './flow-types'

export function detectAvailableRoles(dataElement, identity = null) {
  if (!dataElement || (!dataElement.to && !dataElement.to_agents)) {
    return {
      hasContributorToConsumer: false,
      hasPOB: false,
      hasPOBOP: false,
      hasContributorToAgent: false,
      roles: [],
    }
  }

  const roles = new Set()
  let hasPOB = false
  let hasPOBOP = false
  let hasContributorToConsumer = false
  let hasContributorToAgent = false

  const currentOrgId = identity?.organization?.id || null

  if (dataElement.to && Array.isArray(dataElement.to)) {
    dataElement.to.forEach(participant => {
      // Check for POBOP (for_principals exists)
      if (participant.for_principals?.length > 0) {
        hasPOBOP = true
        roles.add(RoleTypes.PROVIDER_ON_BEHALF_OF_PRINCIPALS)
      }

      if (participant.on_behalf_of?.length > 0) {
        // POB only if on_behalf_of contains OTHER organizations (not current org)
        const hasOtherOrgs = participant.on_behalf_of.some(
          contributor => contributor.id !== currentOrgId
        )
        
        if (hasOtherOrgs) {
          hasPOB = true
          roles.add(RoleTypes.PROVIDER_ON_BEHALF_OF)
        }
        
        // Check if current org is in on_behalf_of (direct contribution)
        const hasCurrentOrg = participant.on_behalf_of.some(
          contributor => contributor.id === currentOrgId
        )
        
        // Ensure it's a direct contribution and is not providing on behalf of any principals
        if (hasCurrentOrg && !participant.for_principals) {
          hasContributorToConsumer = true
          roles.add(RoleTypes.CONTRIBUTOR_TO_CONSUMER)
        }
      }
    })
  }

  if (dataElement.to_agents?.length > 0) {
    hasContributorToAgent = true;
    roles.add(RoleTypes.CONTRIBUTOR_OR_PROVIDER_TO_AGENT)
  }

  return {
    hasContributorToConsumer,
    hasPOB,
    hasPOBOP,
    hasContributorToAgent,
    roles: Array.from(roles),
  }
}

export function determineCombinedFlow(roles) {
  const { hasContributorToConsumer, hasPOB, hasPOBOP } = roles

  if (hasContributorToConsumer && hasPOB && hasPOBOP) {
    return CombinedFlows.CONTRIBUTOR_POB_POBOP
  }

  if (hasPOB && hasPOBOP && !hasContributorToConsumer) {
    return CombinedFlows.POB_POBOP
  }

  if (hasContributorToConsumer && hasPOBOP && !hasPOB) {
    return CombinedFlows.CONTRIBUTOR_POBOP
  }

  if (hasContributorToConsumer && hasPOB && !hasPOBOP) {
    return CombinedFlows.CONTRIBUTOR_POB
  }

  if (hasPOBOP && !hasContributorToConsumer && !hasPOB) {
    return CombinedFlows.POBOP_ONLY
  }

  if (hasPOB && !hasContributorToConsumer && !hasPOBOP) {
    return CombinedFlows.POB_ONLY
  }

  if (hasContributorToConsumer && !hasPOB && !hasPOBOP) {
    return CombinedFlows.CONTRIBUTOR_ONLY
  }

  return CombinedFlows.CONTRIBUTOR_ONLY
}

export function getRecipientType(recipient) {
  if (!recipient) {
    return null
  }

  if (recipient.id === 'MY_PITSTOP') {
    return RecipientTypes.MY_PITSTOP
  }

  if (recipient.isAgent) {
    return RecipientTypes.AGENT
  }

  return RecipientTypes.NON_AGENT
}
